import request from '@/api/request'
import type { TodoItem, TodoQuery, TodoStats, TodoFormData, TodoStatus, TodoAggrItem } from '@/types/todo'

export interface ApiResponse<T = any> {
  code: number
  success: boolean
  message: string
  data: T
}

export function getTodoList(params?: TodoQuery) {
  return request.get('/todos', { params }).then((res: any) => res.data as ApiResponse<{ list: TodoItem[]; pagination: { page: number; pageSize: number; total: number } }>)
}

export function getMyTodos(params?: { status?: TodoStatus; page?: number; pageSize?: number }) {
  return request.get('/todos/my-todos', { params }).then((res: any) => res.data as ApiResponse<{ list: TodoItem[]; pagination: { page: number; pageSize: number; total: number } }>)
}

export function getTodoStats(params?: { manualOnly?: number | string }) {
  return request.get('/todos/stats', { params }).then((res: any) => res.data as ApiResponse<TodoStats>)
}

export function getTodoAggr() {
  return request.get('/todos/aggr').then((res: any) => res.data as ApiResponse<{ list: TodoAggrItem[]; total: number }>)
}

export function getTodoById(id: number) {
  return request.get(`/todos/${id}`).then((res: any) => res.data as ApiResponse<TodoItem>)
}

export function createTodo(data: TodoFormData) {
  return request.post('/todos', data).then((res: any) => res.data as ApiResponse<{ id: number }>)
}

export function updateTodo(id: number, data: TodoFormData) {
  return request.put(`/todos/${id}`, data).then((res: any) => res.data as ApiResponse<null>)
}

export function completeTodo(id: number) {
  return request.post(`/todos/${id}/complete`).then((res: any) => res.data as ApiResponse<null>)
}

export function cancelTodo(id: number) {
  return request.post(`/todos/${id}/cancel`).then((res: any) => res.data as ApiResponse<null>)
}

export function postponeTodo(id: number, data: { dueDate: string; dueTime?: string }) {
  return request.post(`/todos/${id}/postpone`, data).then((res: any) => res.data as ApiResponse<null>)
}

export function remindTodo(id: number) {
  return request.post(`/todos/${id}/remind`).then((res: any) => res.data as ApiResponse<{ notified: number }>)
}

export function deleteTodo(id: number) {
  return request.delete(`/todos/${id}`).then((res: any) => res.data as ApiResponse<null>)
}
